module.exports = __webpack_public_path__ + "img/103.bb416f5f.jpg";